/* eslint-disable import/no-cycle */
import api from './api.service';

// Scarica il report via richiesta autenticata (getFile allega il bearer token),
// evitando il 401 del vecchio <a href> diretto verso la rotta protetta.
function fetchPdf(id) {
  return api.getFile(`/reports/${id}/generate-pdf`);
}

// Salva il PDF come file (bottone "scarica").
function downloadPdf(id, filename) {
  return fetchPdf(id).then((response) => {
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', filename || `report-${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(objectUrl);
    return response;
  });
}

// Apre il PDF in una nuova scheda per l'anteprima/stampa immediata.
function openPdf(id) {
  return fetchPdf(id).then((response) => {
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const objectUrl = window.URL.createObjectURL(blob);
    // Non revochiamo subito l'URL: la scheda deve poter caricare il blob.
    window.open(objectUrl, '_blank');
    return response;
  });
}

export const reportService = {
  downloadPdf,
  openPdf,
};
